import React from 'react';
import { usePermissionContext } from '../contexts/PermissionContext';

export default function useModulePermissions(codmodulo) {
  const {
    codusuario,
    isTechnicalUser,
    loadPermissions,
    hasPerm,
    isLoading,
    permissionsByModule
  } = usePermissionContext();

  const lastLoadKeyRef = React.useRef('');

  React.useEffect(() => {
    if (!codusuario || !codmodulo) return;

    const moduleKey = String(codmodulo);
    const currentKey = `${codusuario}-${moduleKey}`;

    if (lastLoadKeyRef.current === currentKey) {
      return;
    }

    lastLoadKeyRef.current = currentKey;
    loadPermissions(codusuario, moduleKey, false); // false só busca na primeira vez true busca sempre no banco;
  }, [codusuario, codmodulo, loadPermissions]);

  const moduleKey = codmodulo ? String(codmodulo) : null;
  const hasModuleLoaded =
    !!moduleKey &&
    Object.prototype.hasOwnProperty.call(permissionsByModule, moduleKey);

  const permissions = moduleKey ? permissionsByModule[moduleKey] || [] : [];
  const loading = moduleKey ? (isLoading(moduleKey) || !hasModuleLoaded) : false;

  /*console.log('modulo passado no useModulePermissions:', codmodulo);
  console.log('moduleKey:', moduleKey);
  console.log('hasModuleLoaded:', hasModuleLoaded);
  console.log('as permissoes encontradas:', permissions);
  console.log('loading:', loading); */

  return {
    hasPerm: (permCode) => {
      if (!moduleKey) return true;
      return hasPerm(moduleKey, permCode);
    },
    loading,
    isTechnicalUser,
    permissions
  };
}